import type { ComputedRef, InjectionKey } from 'vue'

/** Brand colors from a career site (`primaryColor` / `textColor`). */
export type CareerTheme = {
  primary: string | null
  text: string | null
}

const careerThemeKey: InjectionKey<ComputedRef<CareerTheme>> = Symbol('careerTheme')

const emptyTheme = (): CareerTheme => ({ primary: null, text: null })

export function provideCareerTheme(theme: ComputedRef<CareerTheme>) {
  provide(careerThemeKey, theme)
}

export function useCareerTheme() {
  return inject(careerThemeKey, computed(emptyTheme))
}
